import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { requestAuthentication, useAuth } from "@/context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, isLoading } = useAuth()
  const isCheckingAuth = Boolean(isLoading || user?.isLoading)
  const isAuthenticated = Boolean(user?.isAuthenticated)

  useEffect(() => {
    if (isCheckingAuth || isAuthenticated) return
    requestAuthentication("protected-route")
  }, [isCheckingAuth, isAuthenticated])

  if (isCheckingAuth) {
    return (
      <div className="route-auth-loading" aria-live="polite">
        인증 확인 중입니다.
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
